import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=952071fc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=952071fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952071fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('952071fc')) {
      api.createRecord('952071fc', component.options)
    } else {
      api.reload('952071fc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=952071fc&scoped=true&", function () {
      api.rerender('952071fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/Voucher.vue"
export default component.exports